module.exports = __webpack_public_path__ + "img/vpn.cace5026.webp";